export default "__VITE_ASSET__BmIVTYHa__"